import { useEffect, useState } from 'react';
import { Html5QrcodeScanner, Html5QrcodeScanType } from 'html5-qrcode';

interface QRScannerProps {
  onScan: (sessionId: string | null, alarmId?: string) => void;
}

export default function QRScanner({ onScan }: QRScannerProps) {
  const [scannerId] = useState(`qr-reader-${Date.now()}`);

  useEffect(() => {
    const scanner = new Html5QrcodeScanner(
      scannerId,
      {
        fps: 10,
        qrbox: { width: 250, height: 250 },
        rememberLastUsedCamera: true,
        supportedScanTypes: [Html5QrcodeScanType.SCAN_TYPE_CAMERA],
      },
      false
    );

    const onScanSuccess = (decodedText: string) => {
      const joinMatch = decodedText.match(/join\/([a-f0-9\-]+)/i);
      if (joinMatch && joinMatch[1]) {
        const alarmMatch = decodedText.match(/[?&]alarmId=([a-f0-9\-]+)/i);
        scanner.clear();
        onScan(joinMatch[1], alarmMatch?.[1]);
        return;
      }

      const alarmMatch = decodedText.match(/alarm\/([a-f0-9\-]+)/i);
      if (alarmMatch && alarmMatch[1]) {
        scanner.clear();
        onScan(null, alarmMatch[1]);
      }
    };

    const onScanError = (error: any) => {
      // Ignore errors in scanning
      console.debug('Scanner error:', error);
    };

    scanner.render(onScanSuccess, onScanError);

    return () => {
      scanner.clear();
    };
  }, [scannerId, onScan]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 space-y-6">
      <div className="text-center">
        <h1 className="text-3xl font-bold mb-2">🚑 RD med NÖ Einsatzgerät</h1>
        <p className="text-gray-400">QR-Code scannen zum Beitreten</p>
      </div>

      <div id={scannerId} className="w-full max-w-sm"></div>
      <div className="text-center text-sm text-gray-400 max-w-sm">
        <p>Bitten Sie den Leitstellen-Leiter um einen QR-Code. Richten Sie Ihre Kamera auf den Code.</p>
      </div>
    </div>
  );
}
